import { isNativePlatform } from "../lib/nativeAuth";

/**
 * B-44. Open Tradeloft's own page in Android Settings, where location can be
 * turned back on.
 *
 * After a second "Don't allow" Android stops showing the location prompt, so
 * the map's "Try again" cannot ask again and silently lands back on "Location
 * is off". Settings is the only way out, and the map card offers a button to
 * it in the app.
 *
 * The native half is the app's own one-method plugin,
 * android/app/src/main/java/com/cardonomer/app/AppSettingsPlugin.java, under
 * the name "AppSettings". @capacitor/core is imported lazily, like every other
 * native bridge here, so the web bundle and Jest never load it eagerly.
 */

/** True where there is an app settings page to open: the Android app only. */
export const canOpenAppSettings = () => isNativePlatform();

let appSettingsPlugin = null;

/** Resolves true if Settings opened, false on web or if it could not open. */
export const openAppSettings = async () => {
  if (!canOpenAppSettings()) return false;
  try {
    if (!appSettingsPlugin) {
      const { registerPlugin } = await import("@capacitor/core");
      appSettingsPlugin = registerPlugin("AppSettings");
    }
    await appSettingsPlugin.open();
    return true;
  } catch {
    // Nothing better to offer: the card's caption already names the path
    // (Settings > Apps > Tradeloft > Permissions).
    return false;
  }
};
